import {
    buildAccountMenuItems,
    isAccountSessionItem,
    ACCOUNT_ITEM_MY_TICKETS,
    ACCOUNT_ITEM_MANAGE_EVENTS,
    ACCOUNT_ITEM_USER_SETTINGS,
    ACCOUNT_ITEM_LOGOUT,
    ACCOUNT_ITEM_STOP_IMPERSONATING,
} from '%evp_theme/brandbook/account/accountMenu';

function accountActionLinkProps(action) {
    return {
        component: 'a',
        href: action.href,
        ...(action.opensNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
    };
}

function buildAccountActions({
    myTicketsUrl,
    manageEventsUrl,
    userSettingsUrl,
    logoutUrl,
    stopImpersonatingUrl = null,
    translations,
}) {
    const labels = {
        [ACCOUNT_ITEM_MY_TICKETS]: translations.myTickets,
        [ACCOUNT_ITEM_MANAGE_EVENTS]: translations.manageEvents,
        [ACCOUNT_ITEM_USER_SETTINGS]: translations.userSettings,
        [ACCOUNT_ITEM_LOGOUT]: translations.accountLogout,
        [ACCOUNT_ITEM_STOP_IMPERSONATING]: translations.stopImpersonating,
    };

    return buildAccountMenuItems({
        [ACCOUNT_ITEM_MY_TICKETS]: myTicketsUrl,
        [ACCOUNT_ITEM_MANAGE_EVENTS]: manageEventsUrl,
        [ACCOUNT_ITEM_USER_SETTINGS]: userSettingsUrl,
        [ACCOUNT_ITEM_LOGOUT]: logoutUrl,
        [ACCOUNT_ITEM_STOP_IMPERSONATING]: stopImpersonatingUrl,
    }).map(item => ({
        key: item.key,
        icon: item.icon.symbol,
        iconColor: item.iconColor,
        label: labels[item.key],
        href: item.target,
        opensNewTab: !isAccountSessionItem(item.key),
    }));
}

export default buildAccountActions;
export { accountActionLinkProps };
